// extracted by mini-css-extract-plugin
module.exports = {"root":"_2WsHG","animator":"yPN8X","notification-link":"_1AF6N","notificationLink":"_1AF6N"};